import { atom } from "recoil";

export const productItemValueByEditState = atom({
  key: "productItemValueByEditState",
  default: {},
});
